<script lang="ts" module>
  import { onDestroy, onMount } from 'svelte';

  import { TeoCore } from '@/teoCore/TeoCore';
  import { HistoryEntry } from '@/teoCore/text/history/HistoryEntry';
  import BaseCard from '@/ui/elements/card/BaseCard.svelte';
  import CardHeader from '@/ui/elements/card/CardHeader.svelte';
  import VersionButtonGroup from '@/ui/elements/version/VersionButtonGroup.svelte';
  import { useActiveText } from '@/utils/teo-context';
  import { useActiveTextUIPreviousViewValue, useHistory } from '@/utils/teo-context/teo-atoms/text';
</script>

<script lang="ts">
  let teoText = useActiveText();
  let history = useHistory();
  let selectedEntry = $state<HistoryEntry | null>(history.current.at(0) ?? null);
  let previousView = useActiveTextUIPreviousViewValue();
  let restoring = false;
  function selectHistoryEntry(entry: HistoryEntry) {
    entry.select();
    selectedEntry = entry;
  }

  function restoreHistoryEntry(entry: HistoryEntry) {
    restoring = true;
    entry.restore();
    setTimeout(() => {
      selectedEntry = null;
    });
    if (previousView.current) {
      TeoCore.instance.activeText?.ui.update('view', previousView.current);
    }
  }

  onMount(() => {
    selectedEntry = history.current.at(0) ?? null;
    teoText.current.history.viewIsActive = true;
  });

  onDestroy(() => {
    selectedEntry = null;
    if (!restoring) {
      history.current.at(0)?.select();
    }
    teoText.current.history.viewIsActive = false;
  });
</script>

<BaseCard loading={false} hideLine={false}>
  {#snippet header()}
    <CardHeader cardLabel="Letzte Versionen"></CardHeader>
  {/snippet}

  <VersionButtonGroup
    items={history.current}
    onrestore={restoreHistoryEntry}
    onselect={selectHistoryEntry}
    value={selectedEntry}
  />
</BaseCard>
